import React from "react";
import { Container, Text, ButtonContainer, HiButton } from "./contact";

export default function Contact() {
  return (
    <Container>
      <Text>Interested in working together?</Text>
      <Text>Do you have exciting opportunities for me?</Text>
      <ButtonContainer href="mailto:shruedd@gmail.com">
        <HiButton className="white">Say hi!</HiButton>
      </ButtonContainer>
    </Container>
  );
}
